import { PropsWithChildren, createContext, useContext } from 'react';
import useScenarioDuplication from '../sections/Scenarios/hooks/useScenarioDuplication';

type ScenariosListContextType = {
  duplicatingScenarioIds: number[];
  addDuplicatingScenarioId: (scenarioId: number) => void;
  removeDuplicatingScenarioId: (scenarioId: number) => void;
  duplicateScenario: (scenarioId: number, scenarioName: string) => void;
  closeScenarioDuplicationSnackbar: (id: number) => void;
};

const ScenariosListContext = createContext<ScenariosListContextType | null>(null);

export const ScenariosListContextProvider = ({ children }: PropsWithChildren) => {
  const {
    duplicatingScenarioIds,
    addDuplicatingScenarioId,
    removeDuplicatingScenarioId,
    duplicateScenario,
    closeScenarioDuplicationSnackbar,
    DuplicationWatcher,
  } = useScenarioDuplication();

  return (
    <ScenariosListContext.Provider
      value={{
        duplicatingScenarioIds,
        addDuplicatingScenarioId,
        removeDuplicatingScenarioId,
        duplicateScenario,
        closeScenarioDuplicationSnackbar,
      }}
    >
      {children}
      {duplicatingScenarioIds.map((id) => (
        <DuplicationWatcher key={id} id={id} />
      ))}
    </ScenariosListContext.Provider>
  );
};

export const useScenariosListContext = () => {
  const context = useContext(ScenariosListContext);
  if (!context) {
    throw new Error('useScenariosListContext must be used within a ScenariosListContextProvider');
  }
  return context;
};
